import { createFetchContext } from '@/modules/auto-fetch-contex'
import { repeatableTaskService } from '@/modules/tasks/service/repeatable-task-service'
import { listService } from '@/modules/tasks/service/task-list-service'
import { taskService } from '@/modules/tasks/service/task-service'

export const {
  useListService,
  useTaskService,
  useRepeatableTaskService,
  DefaultTaskFetchProvider,
  CustomTaskFetchProvider,
} = createFetchContext('TaskFetch', {
  taskService,
  repeatableTaskService,
  listService,
})
